var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orderBaseInfo"},[_vm._t("order_info_title"),_c('div',{staticClass:"orderBaseInfoTable"},[_vm._t("orderBaseInfoTable")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }